import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import { downloadCDSdocuments } from '../../../src/components/GB_App/api/getGBForm'

const DownloadCDSDocument = (props) => {
  const [documentUrls, setDocumentUrls] = useState([])
  const [isLoading, setIsLoading] = React.useState(false)


  const onButtonClick = async () => {
    setIsLoading(true)
    let response = await downloadCDSdocuments(props.shipId)

    if (response) {
      const { s3urls } = response?.data?.eventMessage

      setDocumentUrls(s3urls)

      s3urls.forEach((url, index) => {
        window.open(url, '_blank', 'noopener,noreferrer')

        // const link = document.createElement('a');
        // link.href = url;
        // link.download = "download";
        // document.location = link.href;
        // link.click();
      })
    }
    setIsLoading(false)

  }

  return (
    <Button
      id='downloadCDSdocumentbutton'
      size='mini'
      key='Download Button'
      className='sv todo-button primaryBtn'
      disabled={isLoading ? true : false}
      onClick={() => {
        onButtonClick()
      }}
    >
      DOWNLOAD CDS DOCUMENT
    </Button>
  )
}

export default DownloadCDSDocument
